export default "__VITE_ASSET__D1PE1E5b__"